import { render, staticRenderFns } from "./Delivered.vue?vue&type=template&id=28e5f56c&scoped=true&"
import script from "./Delivered.vue?vue&type=script&lang=js&"
export * from "./Delivered.vue?vue&type=script&lang=js&"
import style0 from "./Delivered.vue?vue&type=style&index=0&id=28e5f56c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e5f56c",
  null
  
)

export default component.exports